import domready from "domready";
import { runIfDev } from "../utils";
import { formDataToObject } from "../shared/FormSerialization";
import { fetchJson, IFetchJsonException } from "../shared/Fetch";

domready(() => {
	const forms = document.querySelectorAll("form.form-block") as NodeListOf<HTMLFormElement>;
	if (forms.length === 0)
		return;

	forms.forEach(initForm);
});

interface IFormPostResult {
	message: string
}

function initForm(form: HTMLFormElement) {

	form.querySelectorAll("input, textarea, select").forEach(x => x.addEventListener("focus", () => x.classList.remove('is-invalid')));

	if (form.getAttribute("data-use-recaptcha") === "True") {
		window["formReCaptchaOk"] = () => {
			runIfDev(() => console.debug("Captcha ok"));
			const submitButton = form.querySelector("button[type=submit]") as HTMLButtonElement;
			submitButton.disabled = false;
		};

		window["formCaptchaExpired"] = () => {
			runIfDev(() => console.debug("Captcha expired"));
			const submitButton = form.querySelector("button[type=submit]") as HTMLButtonElement;
			submitButton.disabled = true;
		}
	}

	//För formulär som inte har angiven submiturl
	if (!form.action || form.action === document.location.href) {
		form.addEventListener("submit", submitForm);
	}

	runIfDev(() => console.debug("Initialized form", form));
}

const submitForm = async (event: Event) => {
	event.preventDefault();
	event.stopPropagation();

	const form = event.target as HTMLFormElement;
	const errorBox = form.querySelector(".error-box") as HTMLElement;
	const submitButton = form.querySelector("button[type=submit]") as HTMLButtonElement;
	const spinner = form.querySelector(".spinner") as HTMLElement;
	const formPostedBox = form.nextElementSibling as HTMLElement;

	errorBox.style.display = 'none';
	submitButton.disabled = true;
	spinner?.classList.remove("d-none");

	if (!form.checkValidity())
	{
		runIfDev(() => console.debug('Form is not valid', form));
		return;
	}

	const formData = formDataToObject(form);

	try {
		const response = await fetchJson<IFormPostResult>('/form', {
			method: "POST",
			body: JSON.stringify(formData)
		});

		formPostedBox.querySelector(".card-body").innerHTML = response.message;
		formPostedBox.style.display = null;
		form.parentElement.removeChild(form);
	}
	catch (e) {
		var postError = e as IFetchJsonException;

		console.debug(postError.message, postError.errors);

		let errorMessage = `${postError.message}<br>`;
		if (postError.errors && postError.errors.length > 0) {
			errorMessage += "<ul>";
			postError.errors.forEach(error => {
				const field = form.querySelector(`[name=${error.field}]`);
				if (field)
					field.classList.add('is-invalid');
				errorMessage += `<li>${error.message}</li>`;
			});
			errorMessage += "</ul>";
		}
		errorBox.innerHTML = errorMessage;
		errorBox.style.display = null;
	}
	finally {
		submitButton.disabled = false;
		spinner?.classList.add("d-none");
	}

}